import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "tavas_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeader = () => {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const createInquiry = async (payload) => {
  const { data } = await axios.post(`${API}/inquiries`, payload);
  return data;
};

export const login = async (email, password) => {
  const { data } = await axios.post(`${API}/auth/login`, { email, password });
  setToken(data.access_token);
  return data.user;
};

export const getMe = async () => {
  const { data } = await axios.get(`${API}/auth/me`, { headers: authHeader() });
  return data;
};

export const listInquiries = async () => {
  const { data } = await axios.get(`${API}/inquiries`, { headers: authHeader() });
  return data;
};
